import React, { useContext } from 'react';
import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { GridContext } from '../../../../../GridContext';

export interface IObjektVyGruppProps {
  autoFit?: boolean;
  mobileFlex?: boolean;
}

const useStyles = makeStyles()((theme: Theme) => ({
  gridOuterContainer: {
    width: '100%',
    margin: 0,
    display: 'grid',
    gridGap: theme.spacing(1, 1),
    boxSizing: 'border-box',
    gridTemplateColumns: `repeat(auto-fill, minmax(${theme.spacing(27)}, 1fr))`,
    [theme.breakpoints.only('xs')]: {
      width: '100%',
      marginTop: theme.spacing(1),
      gridGap: theme.spacing(0.5),
    },
  },
  autoFit: {
    gridTemplateColumns: `repeat(auto-fit, minmax(${theme.spacing(27)}, 1fr))`,
  },
  mobileFlex: {
    [theme.breakpoints.only('xs')]: {
      display: 'flex',
    },
  },
}));

/**
 * Komponent som visar en subgrupp av fält i ett kort som hör samman, med möjlighet att välja mellan flex och grid
 * Marginal får hela gridden matchar mot padding i sibling med flex
 */
export const ObjektVyKortDel: React.FunctionComponent<
  React.PropsWithChildren<IObjektVyGruppProps>
> = props => {
  const { classes, cx } = useStyles(undefined, {
    props: props as any,
  });
  const gridContext = useContext(GridContext);
  const children = props.children;
  return (
    <>
      {gridContext.inGrid && (
        <div
          className={cx(classes.gridOuterContainer, {
            [classes.autoFit]: gridContext.inGrid && props.autoFit,
            [classes.mobileFlex]: props.mobileFlex,
          })}
        >
          {children}
        </div>
      )}
      {!gridContext.inGrid &&  children }
    </>
  );
};
